import React from 'react';
import PropTypes from 'prop-types';
import { getLocationImage } from 'utils/links';
import { makeStyles } from 'tss-react/mui';
import Image from 'next/legacy/image';

const useStyles = makeStyles()(() => ({
  root: {
    width: '100%',
    height: 'auto',
    borderRadius: 8,
  },
}));

function StaticMap({ width, height, lat, lng, alt = '' }) {
  const { classes } = useStyles();
  return (
    <Image
      className={classes.root}
      src={getLocationImage(width, height, lat, lng)}
      width={width}
      height={height}
      alt={alt}
      layout="intrinsic"
      priority
    />
  );
}

StaticMap.propTypes = {
  alt: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  lat: PropTypes.string.isRequired,
  lng: PropTypes.string.isRequired,
};

export default StaticMap;
